(ns io.daskul.tutorial.webapp.domain.facebook-pages.events
  "Re-frame events for the Facebook page connection flow.

   `start-connect` fetches the OAuth dialog URL from the API (authenticated) and
   then navigates the browser to Facebook — a plain <a> can't carry the JWT."
  (:require
   [re-frame.core :as rf]
   [io.daskul.webapp.aggregates.events :as agg.events]
   [io.daskul.webapp.notifications :as notif]))

;; ============================================================================
;; Pure helpers
;; ============================================================================

(defn connection-status
  "Derive connection status from the facebook-page list.
   Returns {:status :connected :page p} when an active page exists,
   {:status :inactive :page p} when a page exists but isn't active,
   or {:status :not-connected}."
  [pages]
  (if-let [active (first (filter #(= "active" (:state %)) pages))]
    {:status :connected :page active}
    (if-let [p (first pages)]
      {:status :inactive :page p}
      {:status :not-connected})))

;; ============================================================================
;; Connect
;; ============================================================================

(rf/reg-event-fx ::start-connect
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:facebook-pages :connecting?] true)
     :http-xhrio (agg.events/build-request
                  {:method :get
                   :path "/facebook/auth/start"
                   :on-success [::start-connect-success]
                   :on-failure [::start-connect-failure]})}))

(rf/reg-event-fx ::start-connect-success
  (fn [{:keys [db]} [_ response]]
    {:db (assoc-in db [:facebook-pages :connecting?] false)
     :facebook-pages/navigate (:authorize-url response)}))

(rf/reg-event-db ::start-connect-failure
  (fn [db _]
    (assoc-in db [:facebook-pages :connecting?] false)))

;; Full-page navigation to an external URL (Facebook OAuth dialog).
(rf/reg-fx :facebook-pages/navigate
  (fn [url]
    (when url
      (set! (.-href js/window.location) url))))

;; ============================================================================
;; Disconnect — deactivate the stored page (soft) + best-effort FB webhook unsubscribe
;; ============================================================================

(rf/reg-event-fx ::disconnect
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:facebook-pages :disconnecting?] true)
     :http-xhrio (agg.events/build-request
                  {:method :post
                   :path "/facebook/auth/disconnect"
                   :on-success [::disconnect-success]
                   :on-failure [::disconnect-failure]})}))

(rf/reg-event-fx ::disconnect-success
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:facebook-pages :disconnecting?] false)
     :dispatch [::agg.events/list :facebook-page {}]}))

(rf/reg-event-fx ::disconnect-failure
  (fn [{:keys [db]} _]
    {:db (assoc-in db [:facebook-pages :disconnecting?] false)
     :notification (notif/error "Disconnect failed"
                                "We couldn't disconnect the Page. Please try again.")}))

;; ============================================================================
;; Subscriptions
;; ============================================================================

(rf/reg-sub ::connecting?
  (fn [db _]
    (get-in db [:facebook-pages :connecting?] false)))

(rf/reg-sub ::disconnecting?
  (fn [db _]
    (get-in db [:facebook-pages :disconnecting?] false)))
